export default __webpack_public_path__ + "static/media/post_mark.ee44b803.jpg";